import {AxiosError} from 'axios';
import {GET_CANDIDATE_SELECTED_SPECIAL_CONSIDERATION_QUERY_KEY} from '../../constants/queryKeys';
import {useCustomQuery} from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GET_CANDIDATE_SELECTED_SPECIAL_CONSIDERATION_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface specialConsiderationRequestModelList {
  uuid: string;
  applcationStatus: string;
  examLevel: string;
  applicationId: string;
  applicationStatus: string;
  applicationClosed: boolean;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: specialConsiderationRequestModelList) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  enabled?: boolean;
}

export const useGetSelectedSpecialConsideration = ({
                                                     uuid,
                                                     onSuccess,
                                                     onError,
                                                     enabled = true,
                                                   }: Input) => {
  const getSelectedSpecialConsideration = async () => {
    const res = await axiosClient.get<specialConsiderationRequestModelList>(
        GET_CANDIDATE_SELECTED_SPECIAL_CONSIDERATION_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(
      GET_CANDIDATE_SELECTED_SPECIAL_CONSIDERATION_QUERY_KEY,
      getSelectedSpecialConsideration,
      {
        onSuccess,
        onError,
        enabled,
      }
  );
};
